<template>
  <div class="result-box"
       v-show="isShow">
    <van-nav-bar :title="isSuccessPage ? '支付成功' : '支付失败'"
                 left-arrow
                 @click-left="toHome" />
    <div class="pay-result">
      <img :src="isSuccessPage ? require('@/assets/image/success.png') : require('@/assets/image/fail.png')"
           class="logo" />
      <span class="msg">{{ isSuccessPage ? '订单支付成功' : '订单支付失败' }}</span>
      <span class="num"
            v-if="isSuccessPage">{{ param.allPrice }}元</span>
      <span class="detail success"
            v-if="isSuccessPage">
        <span class="strong">普康宝</span>
        支付{{ param.cardPay }}元
        <span v-if="param.cashPay">，现金支付{{ param.cashPay }}元</span>
      </span>
      <span class="detail"
            v-else>支付异常，该订单已为您保存到“待支付”订单中，请尝试重新支付</span>
      <div class="btn-box"
           v-if="isSuccessPage">
        <van-button type="default"
                    @click="toHome">返回</van-button>
        <van-button type="primary"
                    color="#FF931F"
                    @click="toOrder">查看订单</van-button>
      </div>
      <div class="btn-box"
           v-else>
        <van-button type="default"
                    @click="toOrder">查看订单</van-button>
        <!-- TODO:咱不可用 -->
        <van-button type="default"
                    @click="toRePay">重新支付</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Toast } from 'vant'
import axios from 'axios'
import PlatformInteractionUtil from '@/utils/PlatformInteractionUtil'
export default defineComponent({
  name: 'PayResult',
  setup () {
    const route = useRoute()
    const router = useRouter()

    const isSuccessPage = ref(true)

    const isShow = ref(false)

    const param = reactive({
      allPrice: 0,
      cardPay: 0,
      cashPay: 0,
    })

    const orderCode = route.query.orderCode

    const init = async () => {
      const res = await axios.get(`/PKECUser/servOrder/${orderCode}`)
      if (res.errorCode === 0) {
        param.allPrice = res.data.orderAmount || 0
        param.cardPay = res.data.cardMoney || 0
        param.cashPay = res.data.cash || 0
        if (param.allPrice - param.cashPay - param.cardPay > 0) {
          isSuccessPage.value = false
        }
        isShow.value = true
      } else {
        Toast({ type: 'fail', message: res.errorMessage })
      }
    }

    setTimeout(() => {
      init()
    }, 500)

    const toHome = () => {
      const isLuoDiYe = localStorage.getItem('isLuoDiYe') || null
      if (isLuoDiYe) {
        localStorage.removeItem('isLuoDiYe')
        router.push({ path: '/dentistry/index' })
      } else {
        goBackToApp()
      }
    }

    const goBackToApp = () => {
      PlatformInteractionUtil.goBack()
    }

    const toRePay = () => {
      sessionStorage.setItem('isRePay', 1)
      toOrder()
    }

    const toOrder = () => {
      router.push({
        path: '/dentistry/orderDetail',
        query: { orderCode },
      })
    }

    return {
      isSuccessPage,
      param,
      toHome,
      toRePay,
      toOrder,
      isShow,
    }
  },
})
</script>

<style lang="scss" scoped>
.result-box {
  width: 100%;
  :deep(.van-nav-bar__title) {
    font-size: 18px;
    font-weight: bold;
    color: #444444;
  }

  :deep(.van-nav-bar) {
    font-size: 18px;
    font-weight: bold;
    color: #444444;
  }
  :deep(.van-icon) {
    color: #444444;
  }
  .nav-bar {
    width: 100%;
    background-color: rgba(0, 0, 0, 0);
    position: fixed;

    &:after {
      border: none;
    }
  }
  .pay-result {
    display: flex;
    width: 100%;
    align-items: center;
    flex-direction: column;

    .logo {
      width: 30vw;
      height: 30vw;
      margin-top: 4rem;
    }

    .msg {
      margin-top: 1rem;
      font-size: 1.3rem;
      font-weight: bold;
    }

    .num {
      margin-top: 1rem;
      font-size: 1.2rem;
    }

    .detail {
      width: 80%;
      margin-top: 0.8rem;
      font-size: 0.8rem;
      color: #9e9e9e;
      &.success {
        text-align: center;
      }
      .strong {
        color: #000;
      }
    }

    .btn-box {
      display: flex;
      width: 80%;
      margin-top: 2.5rem;
      justify-content: space-around;

      .van-button {
        width: 6rem;
        height: 2.5rem;
      }
    }
  }
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
